import React from "react";
import { useTranslation } from "react-i18next";

const DeliveryTypeReminder = ({ deliveryType, orderNumber }) => {
  const { t } = useTranslation("common");

  if (!deliveryType) return null;

  return (
    <p className="f14 sBold text-dark text-wrap max-w-500px mt-2">
      {t("We remind you that order")} {orderNumber}{" "}
      {t("is scheduled for delivery by")} {deliveryType}
    </p>
  );
};

export default DeliveryTypeReminder;
